import $ from 'jquery';
class Profile {

    constructor(){ 
        this.events();
    }

    events() {
        //  Register Listeners
        $("#profile-last-name").on("focus", this.resetColor.bind(this));        // Change color back to default
        $("#profile-first-name").on("focus", this.resetColor.bind(this));       // Change color back to default
        $("#profile-nickname").on("focus", this.resetColor.bind(this));         // Change color back to default
        $("#profile-email").on("focus", this.resetColor.bind(this));            // Change color back to default
        $("#profile-email").on("focus", this.resetColor.bind(this));            // Change color back to default
        $("#profile-pw1").on("focus", this.resetColor.bind(this));              // Change color back to default
        $("#profile-pw2").on("focus", this.resetColor.bind(this));              // Change color back to default
        $("#profileForm").on('submit', this.validateFields.bind(this));         //  Validate all input fields
        $("#rb-profile-club").on("change", this.clubSelected.bind());
        $("#rb-profile-school").on("change", this.schoolSelected.bind());
        $("#rb-profile-address").on("change", this.addressSelected.bind());
        $("#rb-profile-guest").on("change", this.guestSelected.bind());
        $("#profile-school").on("focus", this.resetColor.bind(this));           // Change color back to default
        $("#profile-address").on("focus", this.resetColor.bind(this));          // Change color back to default
        $("#profile-guest").on("focus", this.resetColor.bind(this));            // Change color back to default
    }


    clubSelected(){
        setRadios(1);
    }
    schoolSelected(){
        setRadios(2);
    }
    addressSelected(){
        setRadios(4);
    }
    guestSelected(){
        setRadios(8);
    }

    resetColor(e){
        // Change color back to default
        $(e.target).css('border-color','');
    }
    validateFields(e){
        $("#profile-error-msg").text("");
        var allValid = true;
        //  Check whether some required fields are missing
        if (!validAlphaField($("#profile-first-name"),1)){
            allValid=false;
        }
        if (!validAlphaField($("#profile-last-name"),1)){
            allValid=false;
        }
        if (!validTextField($("#profile-nickname"),1)){
            allValid=false;
        }
        if (!validEmailField($("#profile-email"), 1)){
            allValid=false;
        }
        if ($("#rb-profile-club").is(':checked')){
            if ($("#profile-club").val() == ""){
                allValid=false;
            }
        }
        if ($("#rb-profile-school").is(':checked')){
            if (!validTextField($("#profile-school"),1)){
                allValid=false;
            }
        }
        if ($("#rb-profile-address").is(':checked')){
            if (!validTextField($("#profile-address"),1)){
                allValid=false;
            }
        }
        if ($("#rb-profile-guest").is(':checked')){
            if (!validTextField($("#profile-guest"),0)){
                allValid=false;
            }
        }
        if ($("#profile-pw1").val() !== $("#profile-pw2").val()){
            $("#profile-pw1").css("border-color", "red");
            $("#profile-pw2").css("border-color", "red");
            $("#profile-error-msg").text("Passwords Don't Match");
            allValid=false;
        }
        if (!allValid){
            e.preventDefault();
        }
    }
}
function checkForDuplicate(){
    var restData = {
        'email': $("#profile-email").val()
    };
    var emailValid = false;
    $.ajax({
        beforeSend:(xhr) => {
            xhr.setRequestHeader('X-WP-Nonce',dysData.nonce);
        },
        url: dysData.root_url + '/wp-json/results/v1/userEmailCheck/',
        type: 'POST',
        async: true,
        data: restData,
        success: (response) => {
            switch(response){
                case 'OK':
                    emailValid = true;
                    break;
                case 'EXISTS':
                    $("#profile-err-msg").text('Email already in use by another user');
                    break;
                case 'EXISTS':
                    $("#profile-err-msg").text('Email format invalid');
                    break;
            }
        },
        error: (response) => {
            console.log("Invalid Data Response");
            console.log(response);
            $("#profile-err-msg").text('Unable To Update User Profile, Please try Later');
        }
    });
    return "OK";
}

function validAlphaField( field, minLength ){
    var fieldText = $(field).val();
    var fieldValid = true;
    if (fieldText.length < minLength ){
        fieldValid = false;
    } else {
        if (!fieldText.match(/^[A-Za-z ]+$/) && fieldText.length != 0){
            fieldValid = false;
        }
    }
    if (!fieldValid){
        field.css("border-color", "red");
    }
    return fieldValid;
}
function validTextField( field, minLength ){
    var fieldText = $(field).val();
    var fieldValid = true;
    if (fieldText.length < minLength ){
        fieldValid = false;
    } else {
        if (!fieldText.match(/^[A-Za-z0-9 ]+$/) && fieldText.length != 0){
            fieldValid = false;
        }
    }
    if (!fieldValid){
        field.css("border-color", "red");
    }
    return fieldValid;
}

function validEmailField( field, minLength ){
    var fieldText = $(field).val();
    var fieldValid = true;
    if (fieldText.length < minLength ){
        fieldValid = false;
    } else {
        if (!fieldText.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)){
            fieldValid = false;
        }
    }
    if (!fieldValid){
        field.css("border-color", "red");
    }
    return fieldValid;
}

function setRadios(radio){
    if ((radio & 1) == 1){
        $("#club-data").hide();
        $("#club-data").removeClass('d-none');
        $("#club-data").fadeIn(500);
    } else {
        $("#club-data").fadeOut(500);
        $("#club-data").addClass('d-none');
    }
    if ((radio & 2) == 2) {
        $("#school-data").hide();
        $("#school-data").removeClass('d-none');
        $("#school-data").fadeIn(500);
    } else {
        $("#school-data").fadeOut(500);
        $("#school-data").addClass('d-none');
    }
    if ((radio & 4) == 4) {
        $("#address-data").hide();
        $("#address-data").removeClass('d-none');
        $("#address-data").fadeIn(500);
    } else {
        $("#address-data").fadeOut(500);
        $("#address-data").addClass('d-none');
    }
    if ((radio & 8) == 8) {
        $("#guest-data").hide();
        $("#guest-data").removeClass('d-none');
        $("#guest-data").fadeIn(500);
    } else {
        $("#guest-data").fadeOut(500);
        $("#guest-data").addClass('d-none');
    }
}

export default Profile;